import type { DPMonth } from "@rehookify/datepicker";
import { format } from "date-fns";
import { enUS, es } from "date-fns/locale";

import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { useSettingsStore } from "@/shared/stores";
import { SelectPrimitive } from "@/shared/ui/form";

interface MonthSelectProps {
  months: DPMonth[];
  month: number;
  onChange: (month: number) => void;
}

export const MonthSelect = ({ months, month, onChange }: MonthSelectProps) => {
  const locale = useSettingsStore((state) =>
    state.language === AVAILABLE_LANGUAGE.ES ? es : enUS,
  );

  return (
    <SelectPrimitive.Root
      value={month.toString()}
      onValueChange={(value) => onChange(parseInt(value))}
    >
      <SelectPrimitive.Trigger
        id="month-selector-trigger"
        className="capitalize"
      >
        <SelectPrimitive.Value placeholder="Select year..." />
      </SelectPrimitive.Trigger>

      <SelectPrimitive.Content align="center">
        {months.map((dPMonth) => (
          <SelectPrimitive.Item
            key={dPMonth.$date.toDateString()}
            value={dPMonth.$date.getMonth().toString()}
            className="capitalize"
          >
            {format(dPMonth.$date, "MMMM", { locale })}
          </SelectPrimitive.Item>
        ))}
      </SelectPrimitive.Content>
    </SelectPrimitive.Root>
  );
};
